<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Create a Setting</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Name ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Name</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="name" [(ngModel)]="data.name" required>
                        </div>
                    </div>

                    <!-- ___ Buildings  ___ -->
                    <div class="row m-b-sm" style="overflow: visible;">
                        <div class="col-md-4 m-t-xs apart-btns">
                            <label>Buildings</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="buildings"
                                                  [data]="settingsIncidentReportService.buldingsInMultiselectFormat"
                                                  [(ngModel)]="data.buildings"
                                                  [settings]="multiselectSettings" required>
                            </angular2-multiselect>
                        </div>
                    </div>


                    <div class="row text-center m-b-lg m-t-md">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report-modal/settings-incident-report-modal.component.html